import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  output,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { FileDialogComponent } from "../file-dialog/file-dialog.component";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { DialogsService } from "../../../../shared/services/dialogs/dialogs.service";
import { DocumentFacadeService } from "../../services/store/document-facade.service";
import { firstValueFrom } from "rxjs";
import mime from "mime";
import { ChipsComponent } from "../../../../shared/modules/chips/chips.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ConfirmationDialogComponent } from "../../../../shared/components/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "vl-file-viewer-local",
  templateUrl: "./file-viewer-local.component.html",
  styleUrls: ["./file-viewer-local.component.scss"],
  standalone: true,
  imports: [NgClass, ChipsComponent, NgxSkeletonLoaderModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileViewerLocalComponent {
  documentFacade = inject(DocumentFacadeService);
  sanitizer = inject(DomSanitizer);
  private dialogsService = inject(DialogsService);

  width = input<string>();
  height = input<string>();
  maxHeight = input<string>();
  maxWidth = input<string>();
  readOnly = input<boolean>();
  showPdf = input<boolean>();
  opacity = input<number>(1);
  opacitygradient = input<boolean>(false);
  borderradius = input<boolean>(true);
  deactivateVisu = input(false);
  showActions = input(false);
  filename = input<string>();

  delete = output();

  file = this.documentFacade.getBySignalId(this.filename);
  metaData = this.documentFacade.getMetadataBySignalId(this.filename);

  contentType = computed(() => {
    if (this.file()) {
      return mime.getType(this.file().path);
    }
  });

  sanitizedUrl = computed(() => {
    const url = this.file()?.url;
    if (url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    return null;
  });

  constructor() {
    effect(
      () => {
        if (this.filename()) {
          this.documentFacade.loadById(this.filename());
        }
      },
      { allowSignalWrites: true },
    );
  }

  onImageClick(event: MouseEvent) {
    if (this.deactivateVisu()) {
      return;
    }
    event.stopPropagation();
    this.openFile();
  }

  async openFile() {
    if (this.deactivateVisu()) {
      return;
    }

    const dialogRef = this.dialogsService.open(
      FileDialogComponent,
      "fit-content",
      "fit-content",
      { fileTypeId: this.filename(), readOnly: this.readOnly() },
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res === "delete") {
      this.delete.emit();
    }
  }

  async onDelete() {
    const dialogRef = this.dialogsService.open(
      ConfirmationDialogComponent,
      "fit-content",
      "fit-content",
      {
        title: "Suppression",
        message:
          "Vous êtes sur le point de supprimer le document. Confirmez-vous ?",
      },
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      this.delete.emit();
    }
  }
}
